$(document).ready(function () {
	window['initColorThemes']();
	window['initPopup']();
	window['initBooking']();
	// window['customAccordionPositioning']();
	window['customNewsletterForm']();
	window['customPDFLinks']();
	window['initHideVideoMobile']();
	window['initWeddingDatePicker']();
	window['customOffersDetail']();
	window['initLazyLoading']();
});
				

var initHideVideoMobile = function () {
	if ($('.slider__video').length > 0) {

		if ($( window ).width() < 640) {
			$('.slider__inner').hide();
			$('.wrapper').css('margin-top', 115);
		} else {
			$('.slider__inner').show();
			$('.wrapper').css('margin-top', 0);
		}
	}
}

$(window).on('resize', initHideVideoMobile);


// Customised version to deal with smaller logo required for scroll
var initHeader = function () {

	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last,
		  deferTimer;
	  return function () {
		var context = scope || this;

		var now = +new Date,
			args = arguments;
		if (last && now < last + threshhold) {
		  // hold on to it
		  clearTimeout(deferTimer);
		  deferTimer = setTimeout(function () {
			last = now;
			fn.apply(context, args);
		  }, threshhold);
		} else {
		  last = now;
		  fn.apply(context, args);
		}
	  };
	}

	// Detect if the header is over and image slider, if yes then give it a transparent background
	setHeaderTransparency();
	$(window).on('scroll', setHeaderTransparency);

	$('.header').addClass('visible'); // only show the header after the transparency has been set

	function setHeaderTransparency() {
		if (window.pageYOffset < 150) {
			$('.header').removeClass('header--scrolled');
			if ($('.slider').length > 0) {
				$('.header').addClass('header--transparent');
			}
		} else {
			$('.header').addClass('header--scrolled');
			$('.header').removeClass('header--transparent');
		}
	}

	if( ($('body').hasClass('dark-green')) || ($('body').hasClass('light-green')) ) {
		$('.header__logo .green-logo').addClass('active');
		$('.header__logo .dark-gold-logo').removeClass('active');
	} else if ( $('body').hasClass('dark-gold') ) {
		$('.header__logo .green-logo').removeClass('active');
		$('.header__logo .dark-gold-logo').addClass('active');
	}
}

function pushContentBelowHeader() {
	$('main').css('padding-top', $('.header__inner').outerHeight());
	$('.gradient').css('padding-top', '0px');
}

var initSlider = function () {
	var sliderSettings = settings.slider;
	sliderSettings.speed = 6000;

	$('.slider__inner').reformSlider(
		sliderSettings
	);

	if ($('.slider__video').length > 0) {
		// Make sure the slider always fills the whole screen
		coverViewport($('.slider__video iframe'), true);
		$(window).on('resize', function () {
			coverViewport($('.slider__video iframe'), true);
		});
	}

	// If there's no slider, make sure that the content starts below the header
	if ($('.slider').length === 0) {
		pushContentBelowHeader();
		$(window).on('resize', pushContentBelowHeader);
		//$('.header').addClass('header--transparent');
	}
}






var initAnimateInView = function () {
	$(window).on('DOMContentLoaded load resize scroll', animateElementsInView);
	animateElementsInView();
}

function animateElementsInView() {
	$('[data-animate-in-view]').each(function () {
		if ( $(this).hasClass('in-view') ) {
			return;
		}

		if ( isElementInViewport($(this)) ) {
			var elementToAnimate = this;

			$(elementToAnimate).addClass('in-view'); // log that this element has been seen


			setTimeout(function () {
				$(elementToAnimate).addClass( $(elementToAnimate).data('animate-in-view') ); // apply the animation class
			}, 300);


			if ( typeof $(elementToAnimate).data('map-load-on-view') != 'undefined' ) { // only load this map once it's in view
				buildMap(elementToAnimate);
			}
		}
	});
}

function isElementInViewport (el) {
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}

	var rect = el.getBoundingClientRect();

	var t = rect.y;
	var b = window.innerHeight - rect.y - rect.height;
	var h = window.innerHeight;

	if (
		( (t >= 0) && (t <= h) ) ||
		( (b >= 0) && (b <= h) )
	) {
		return true;
	} else {
		return false;
	}
}





var initOtherRooms = function () {
	// Custom colours since the carousel item ordering breaks CSSs odd/even styles
	$('.other-rooms__room:nth-child(even)').addClass('other-rooms__item--even');


	$('.other-rooms__carousel').on('init', function (event, slick) {
		Foundation.reInit('equalizer');
	});

	$('.other-rooms__carousel').slick({
		slidesToShow: 2,
		arrows: true,
		responsive: [
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
}







var initAccommodation = function () {
	$('.accommodation__views button').on('click', function () {
		if ( $(this).hasClass('current') ) {
			return;
		}

		// Remove the transition classes to avoid the weird morphing effect
		$('.accommodation .transition--2000').removeClass('transition--2000');

		// Switch the button current states
		$('.accommodation__views button.current').removeClass('current')
		$(this).addClass('current');

		$('.accommodation__items').toggleClass('accommodation__items--list-view').toggleClass('accommodation__items--grid-view');
	});

	if ( window.innerWidth < 640 ) {
		$('.accommodation__items').removeClass('accommodation__items--list-view').addClass('accommodation__items--grid-view');
	}
}






var initColorThemes = function () {

}




var customMapStyle = [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#614e5d"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#e3ded7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#d6dcd8"}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":100},{"visibility":"simplified"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"visibility":"on"},{"lightness":700}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#95b0c0"}]}];

var initMaps = function () {
	$('[data-map]').each(function () {
		var map, centerLat, centerLng, zoom, marker, markerLat, markerLng;

		if (typeof $(this).data('map-center-coords') != 'undefined') {
			centerLat = parseFloat( $(this).data('map-center-coords').split(',')[0] );
			centerLng = parseFloat( $(this).data('map-center-coords').split(',')[1] );
		} else {
			centerLat = 0;
			centerLng = 0;
		}

		zoom = $(this).data('map-zoom') || 8;

		if ((typeof settings.mapStyle !== 'undefined') || (settings.mapStyle === false))  {
			map = new google.maps.Map($(this)[0], {
				center: {lat: centerLat, lng: centerLng},
				zoom: zoom,
				zoomControl: true,
				zoomControlOptions: {
					position: google.maps.ControlPosition.LEFT_BOTTOM
				},
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,

				styles: customMapStyle
			});
		} else {
			map = new google.maps.Map($(this)[0], {
				center: {lat: centerLat, lng: centerLng},
				zoom: zoom,
				zoomControl: true,
				zoomControlOptions: {
					position: google.maps.ControlPosition.LEFT_BOTTOM
				},
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false
			});
		}


		if (typeof $(this).data('map-marker-coords') != 'undefined') {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}

			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});

			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		}

		$(this).siblings('[data-map-marker]').each(function () {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}

			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});

			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		});

		if (typeof $(this).data('map-directions') != 'undefined') {
			var directionsService  = new google.maps.DirectionsService();
			var directionsRenderer = new google.maps.DirectionsRenderer();
			directionsRenderer.setMap(map);
			directionsRenderer.setPanel($('#map-directions-data').get(0));

			var directionsTo = $(this).data('map-directions-destination');

			$('#frmPostcode').on('submit', function() {
				var directionsFrom = jQuery.trim(jQuery('#tbPostcode').val());
				var directionsRequest = {
					origin: directionsFrom,
					destination: directionsTo,
					travelMode: google.maps.TravelMode.DRIVING,
					unitSystem: google.maps.UnitSystem.IMPERIAL
				};

				directionsService.route(directionsRequest, function(result, status){
					if (status == google.maps.DirectionsStatus.OK) {
						marker.setMap(null);
						directionsRenderer.setDirections(result);
					} else {
						alert('Location "' + directionsFrom + '" not found.');
					}
				});

				return false;
			});
		}
	});
}








var initOffCanvas = function () {
	//$('#offCanvas').foundation('open');

	$('.off-canvas__nav-primary > ul > li').each(function () {
		// Automatically add the "Overview" links to the landing page
		if ( $(this).find('ul').length > 0 ) {
			var overviewLink = $(this).find('a').first().attr('href');
			$(this).find('ul').prepend('<li><a href="' + overviewLink + '">Overview</a></li>');
		}
	});


	$('.off-canvas__nav-primary > ul > li > a').on('click', function () {
		if ( $(this).next('.off-canvas__nav-sub').length > 0 ) { // only trigger if there are sub pages to show
			if ( $(this).parent().hasClass('open') ) {
				// second click of main item allows clicking directly through
				return true;
			} else {
				// close any other open items
				$('.off-canvas__nav-primary > ul > li.open').removeClass('open').find('.off-canvas__nav-sub').slideUp();

				// and open the new one
				$(this).parent().addClass('open');
				$(this).next().slideDown();
			}
			return false; // prevent navigating
		}
	});
}





var initPopup = function () {
	if ($('#popup').length > 0) {
		var popupDelay = $('#popup').data('popup-delay') || 0;
		var popupKeepHiddenFor = $('#popup').data('popup-keep-hidden-for-n-days') || 0;

		if (!Cookies.get('hasSeenPopup')) {
			setTimeout(function() {
				$('#popup').foundation('open');

				if (popupKeepHiddenFor > 0) {
					Cookies.set('hasSeenPopup', 'true', { expires: popupKeepHiddenFor });
				}
			}, popupDelay);
		}
	}
}


// https://be.synxis.com/?&adult=1&arrive=2020-10-19&chain=5301&child=0&currency=GBP&depart=2020-10-20&hotel=5160&level=hotel&locale=en-GB&rooms=1
var initBooking = function () {


	$('#booking').on('open.zf.reveal', function () {
		// Only load 3rd party iframes when the booking panel is opened
		$('#booking iframe').each(function () {
			if (typeof $(this).data('src') != 'undefined') {
				$(this).attr('src', $(this).data('src'));
			}
		});
	});


	//$('#booking').foundation('open');

	$('.booking select').selectric();

	$('.booking__tabs-content-room-why-book').accordiom({
		showFirstItem: false
	});

	var bookingContainer = $('.booking__tabs-content-room form');
	var monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
	var dayNames   = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];
	var nowTemp = new Date();
	var tomorrow = new Date();
		tomorrow.setDate(nowTemp.getDate() + 1);

	var $checkInField = bookingContainer.find('.check-in');
	var $checkOutField = bookingContainer.find('.check-out');

	$checkInField.on('hide.datepicker', function () {
		var checkInDate  = $checkInField.datepicker('getDate');
		var checkOutDate = $checkOutField.datepicker('getDate');
		var dayAfterCheckIn = new Date(checkInDate);
			dayAfterCheckIn.setDate(checkInDate.getDate() + 1);

		// Ensure checkout comes after checkin.
		// Otherwise it all gets a bit Restaurant at the End of the Universe-ey.
		if ( checkInDate >= checkOutDate ) {
			$checkOutField.datepicker('setDate', dayAfterCheckIn);
		}

		$checkOutField.datepicker('setStartDate', dayAfterCheckIn);

		$checkOutField[0].focus();
	});

	var checkin = $checkInField.datepicker({
		format: 'dd',
		autoPick: true,
		autoHide: true,
		date: null,
		startDate: nowTemp,
		pick: function (e) {
			// User-facing date fields
			$('.check-in-month-year').text( monthNames[e.date.getMonth()] + ' ' + e.date.getFullYear() );
			$('.check-in-day').text( dayNames[e.date.getDay()] );

			// Formatted date for the booking engine
			$('input[name="arrive"]').val( e.date.getFullYear() + '-' + pad( e.date.getMonth() + 1*1 , 2) + '-' + e.date.getDate() );
		}
	});

	var checkout = $checkOutField.datepicker({
		format: 'dd',
		autoPick: true,
		autoHide: true,
		date: null,
		startDate: tomorrow,
		pick: function (e) {
			// User-facing date fields
			$('.check-out-month-year').text( monthNames[e.date.getMonth()] + ' ' + e.date.getFullYear() );
			$('.check-out-day').text( dayNames[e.date.getDay()] );

			// Formatted date for the booking engine
			$('input[name="depart"]').val( e.date.getFullYear() + '-' + pad( e.date.getMonth() + 1*1 , 2) + '-' + e.date.getDate() );
		}
	});
}

function pad(n, width, z) {
	z = z || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}



var initGallery = function () {
	$('.gallery__item a').on('click', function () {
		// Dynamically load the gallery slider into a reveal popup
		var modal = '<div id="gallery__modal" class="gallery__modal full reveal loading" data-reveal><button class="gallery__modal-close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><div class="gallery__modal-image"><img src="{{src}}"><button class="gallery__modal-prev">Previous</button><button class="gallery__modal-next">Next</button></div><div class="gallery__modal-content grid-x grid-margin-x"><div class="gallery__modal-caption cell small-12 medium-6">{{caption}}</div><div class="gallery__modal-cta cell small-12 medium-6">{{cta}}</div></div></div>';

		modal = modal.replace('{{src}}', $(this).attr('href'));
		modal = modal.replace('{{caption}}', $(this).data('title') || '');

		var cta = $(this).data('description') || '';
		if ( ( typeof $(this).data('book-link') !== 'undefined' ) && ( $(this).data('book-link') !== '' ) ) {
			cta += '<a href="' + $(this).data('book-link') + '" class="button button--green" target="_blank">' + ($(this).data('book-title') || 'Book Now') + '</a>';
		}
		modal = modal.replace('{{cta}}', cta);

		var $modal = modal;

		$('body').append($modal);

		$('#gallery__modal').foundation().on('closed.zf.reveal', function () {
			$('#gallery__modal').remove();
		});

		$('#gallery__modal').foundation('open');

		return false;
	});

	refreshMasonry();
	$('.gallery').on('filter-changed', function () {
		setTimeout(refreshMasonry, 600);
	});

	Foundation.onImagesLoaded($('.gallery__item img'), refreshMasonry);

	function refreshMasonry() {
		$('.gallery__grid').masonry({
			columnWidth: '.gallery__item-sizer',
			itemSelector: '.gallery__item',
			percentPosition: true,
			horizontalOrder: true
		});
	};

	// Remove the transition class after loading to avoid jumpy thumbnails
	setTimeout(function () {
		$('.gallery__item').removeClass('transition--2000');
	}, 2000);



	// Remove empty filter buttons (if not handled by the plugin)
	$('.filter__buttons button').each(function () {
		if ( $(this).text() == '' ) {
			$(this).remove();
		}
	});
}


// The design of the accordion button being positioned to the left, means that depending on the amount of content in the button, each accordionContent needs to be pulled up by a different amount...
// var customAccordionPositioning = function () {
// 	if ( $('.accordion').length > 0 ) {
// 		pullUpAccordionContent();
// 		$(window).on('resize', pullUpAccordionContent);
// 	}
// }

// function pullUpAccordionContent() {
// 	if ( $(window).innerWidth() > 640 ) {
// 		$('.accordion .accordionContent').each(function () {
// 			$(this).css('margin-top', '-' + ($(this).prev().find('h3').innerHeight() + 38*1) + 'px');
// 		});
// 	} else {
// 		$('.accordion .accordionContent').css('margin-top', '0');
// 	}
// }


function customNewsletterForm() {
	// 2 inputs with the same ID on the same page doesn't work... have to manually trigger the footer checkbox when clicking on the label
	$('.footer .footer__newsletter-form label').on('click', function () {
		$(this).siblings('input[type="checkbox"]').each( function () {
			$(this).prop("checked", !$(this).prop("checked"));
		});
	});

	$('.contact-newsletter select').selectric();
}


var customPDFLinks = function () {
	// Automatically set PDFs to open in new windows
	$('a[href$=".pdf"]').attr('target', '_blank');
}


// $('.contact form').each(function(){
//     $(this).append('<div class="g-recaptcha" data-sitekey="6LfmdbAaAAAAAKiI_ANWO4WQ4N78EgKOKtuE1Aci"></div>'); 
// });


var initWeddingDatePicker = function() {
	var nowTemp = new Date();
	var $weddingDateField = $('.contact__form .wedding-date')

	var weddingDay = $weddingDateField.datepicker({
		format: 'dd/mm/yyyy',
		autoPick: false,
		autoHide: true,
		date: null,
		startDate: nowTemp
	});
}


var customOffersDetail = function () {
	$('.detail__inner').each(function () {
		if ( $(this).children().length === 0 ) {
			$(this).remove();
		}
	});
}

function initLazyLoading() {
    var lazyImages = Array.from($("[data-style], .lazy > source, .lazy-img"));

    var options = {
        root: null,
        rootMargin: "150px 0px",
        threshold: 0,
      };

    var lazyImageObserver = new IntersectionObserver(callbackObserver, options);


    function presetImgSizeStyles(img) {
        if (
            img.nodeName === "SOURCE" ||
            img.nodeName === "DIV" ||
            img.classList.contains("bg-img") ||
            typeof img.dataset.presets !== "undefined"
          ) {
            return;
          }
      
          img.style.width = "100%";
          img.style.height = "auto";
          img.style.display = "block";
          img.decoding = "async";
      }      
    
    function setImageViewportWidth(img) {
        var windowWidth = window.innerWidth;
        var imgWidth = img.clientWidth;
        var imgViewportWidth = Math.floor((imgWidth / windowWidth) * 100) + "vw";
        img.sizes = imgViewportWidth;
      }

    function handleImgSrcset(img) {
        setImageViewportWidth(img);
        img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        delete img.dataset.srcset;
        delete img.dataset.src;
        lazyImageObserver.unobserve(img);
       
      }

    function handleImgTag(img) {
        img.src = img.dataset.src;
        delete img.dataset.src;
        lazyImageObserver.unobserve(img);
    }  

    function handleBackgroundImg(img) {
        img.style = img.dataset.style; 
        delete img.dataset;
        lazyImageObserver.unobserve(img);
      }

    function handlePictureElement(img) {
        if (img.nextElementSibling.nodeName === "IMG") {
          img.nextElementSibling.src = img.nextElementSibling.dataset.src;
          delete img.nextElementSibling.dataset.src;
        }
        
        img.srcset = img.dataset.srcset;
        delete img.dataset.srcset;
    
        img.parentElement.classList.remove("lazy");
        lazyImageObserver.unobserve(img);
    }  

    function callbackObserver(entries) {
        entries.forEach(function(entry) {
          var img = entry.target;
          
          if (!entry.isIntersecting) return;
    

          if (img.nodeName === "IMG" && typeof img.dataset.srcset !== 'undefined') {
            handleImgSrcset(img);
			return 
          }

          if (img.nodeName === "IMG" && typeof img.dataset.srcset === "undefined") {
            handleImgTag(img); 
			return
          }

          if (img.nodeName === "DIV") {
            handleBackgroundImg(img);
			return
          }

		  if (img.parentElement.nodeName === "PICTURE") {
            handlePictureElement(img);
			return
          }

          lazyImageObserver.unobserve(img);
        });
      }

      lazyImages.forEach(function (img) {
        presetImgSizeStyles(img)
      })
    
      lazyImages.forEach(function (img) {
        lazyImageObserver.observe(img);
      });
}